import React from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ExperimentOutlined } from '@ant-design/icons';
import '../css/NotFound.css';

const NotFound_en = () => (
  <div className="lang-en">
    <section className="notfound-section">
      <Helmet>
        <title>Page Not Found - Tang Wu Biotech</title>
        <meta name="description" content="The page you are looking for does not exist." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="container-narrow notfound-container">
        <div className="notfound-icon-wrap">
          <ExperimentOutlined className="notfound-icon" />
        </div>

        <div className="notfound-code">404</div>

        <h1 className="big-title-ch">Recipe Not Found</h1>
        <p className="content-en notfound-message">
          The page you're looking for may have been moved, <br />
          or the URL might be incorrect.
        </p>
      </div>
    </section>
  </div>
);

export default NotFound_en;
